import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

export const interactionMetrics: {
	sendMessage: Metric;
	initializeChannels: Metric;
	timeToFirstAnswerPart: Metric;
	sendConfirmedToolsTimeToFinishStream: Metric;
	sendConfirmedToolsTimeToFirstAnswerPart: Metric;
} = {
	sendMessage: metrics.interaction({
		key: 'ai-mate.send-message',
	}),
	initializeChannels: metrics.interaction({
		key: 'ai-mate.initialize-channels',
	}),
	timeToFirstAnswerPart: metrics.interaction({
		key: 'ai-mate.time-to-first-answer-part',
	}),
	sendConfirmedToolsTimeToFinishStream: metrics.interaction({
		key: 'ai-mate.send-confirmed-tools.time-to-finish-stream',
	}),
	sendConfirmedToolsTimeToFirstAnswerPart: metrics.interaction({
		key: 'ai-mate.send-confirmed-tools.time-to-first-answer-part',
	}),
} satisfies Record<string, Metric>;
